import React from 'react';
import { createPureComponent, PathUtils } from 'module/Common';
import { NavProvider } from 'module/View/Common';
import { connect } from 'react-redux';
import { State } from 'module/Redux';
import { RouterSelector } from 'module/Redux/Router';
import { Wrapper, LangLink } from './LangTopBar.s';

type StateProps = {
  otherLang: PathUtils.Lang;
};

const mapStateToProps = (s: State): StateProps => ({
  otherLang: RouterSelector.selectOtherLang(s),
});

type OwnProps = {};

type Props = StateProps & OwnProps;

const LangTopBarComp = createPureComponent<Props>('LangTopBar', ({ otherLang }) => {
  return (
    <Wrapper>
      <NavProvider lang={otherLang}>
        {params => <LangLink {...params.getAnchorProps()}>{otherLang === 'fr' ? 'Français' : 'English'}</LangLink>}
      </NavProvider>
    </Wrapper>
  );
});

export const LangTopBar = connect(mapStateToProps)(LangTopBarComp);



// WEBPACK FOOTER //
// ./src/module/View/Main/LangTopBar/index.tsx